import React from 'react';
import styled from 'styled-components';

export const LegalPageContent = styled.div`
  max-width: 900px;
  margin: 0 auto;
  text-align: left;
`;

export const LegalLastUpdated = styled.p`
  font-size: 14px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(29, 51, 78, 0.6);
  margin-bottom: 24px;
`;

export const LegalSection = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== '$compact',
})`
  margin-bottom: ${({ $compact }) => ($compact ? '40px' : '48px')};

  &:last-child {
    margin-bottom: 0;
  }
`;

export const LegalSectionTitle = styled.h3`
  font-size: clamp(20px, 4vw, 24px);
  font-weight: 700;
  color: #1d334e;
  margin-bottom: 16px;
`;

export const LegalParagraph = styled.p`
  font-size: 16px;
  color: rgba(29, 51, 78, 0.8);
  line-height: 1.5;
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const LegalBulletList = styled.ul`
  margin: 0 0 10px;
  padding-left: 20px;
  list-style: disc;

  li {
    font-size: 16px;
    color: rgba(29, 51, 78, 0.8);
    line-height: 1.5;
    margin-bottom: 10px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const LegalSubsectionTitle = styled.h4`
  font-size: 18px;
  font-weight: 600;
  color: #1d334e;
  margin-bottom: 12px;
`;

export const LegalInfoLine = styled.p`
  font-size: 16px;
  color: rgba(29, 51, 78, 0.8);
  line-height: 1.5;
  margin-bottom: 8px;
`;

/**
 * Shared renderer for Terms, Privacy, Legal Notice, Disclaimer body fragments.
 */
export function renderLegalContent(content, isSubsection = false) {
  if (Array.isArray(content)) {
    if (isSubsection && content.length > 1) {
      return (
        <LegalBulletList>
          {content.map((item, index) => (
            <li key={index}>{typeof item === 'string' ? item : String(item ?? '')}</li>
          ))}
        </LegalBulletList>
      );
    }

    const bullets = content.every((item) => typeof item === 'string' && item.trim().startsWith('• '));

    if (bullets) {
      return (
        <LegalBulletList>
          {content.map((item, index) => (
            <li key={index}>{item.replace(/^•\s*/, '')}</li>
          ))}
        </LegalBulletList>
      );
    }

    return content.map((item, index) => (
      <LegalParagraph key={index}>{typeof item === 'string' ? item : String(item ?? '')}</LegalParagraph>
    ));
  }

  if (typeof content === 'string') {
    return <LegalParagraph>{content}</LegalParagraph>;
  }

  return null;
}
